/* eslint-disable react/prop-types */
import React, { memo, useEffect, useState } from "react";
import { Box, Switch, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";
import DatePicker from "react-flatpickr";
import SoftDatePicker from "components/SoftDatePicker";
import { Vietnamese } from "flatpickr/dist/l10n/vn";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  minWidth: 100,
};

const selectStyle = {
  minWidth: 100,
  fontSize: 13,
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
};

const Td = ({ children, style, ...rest }) => {
  return (
    <td {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </td>
  );
};

function TaxPersonalTable({ setFieldValue }) {
  const [data, setData] = useState([
    {
      id: uuidV4(),
      value2: "",
      value3: "",
      value4: "",
      value5: "",
      value6: "",
      value7: false,
      value8: false,
      value9: "",
      value10: "",
      value11: "",
      value12: "",
      value13: "",
      value14: "",
      value15: "",
      value16: "",
      value17: "",
      value18: "",
      value19: "",
      value20: "",
      value21: "",
      value22: "",
      value23: "",
    },
  ]);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { name, value } = values;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const handleAdd = () => {
    const newRow = {
      id: uuidV4(),
      value2: "",
      value3: "",
      value4: "",
      value5: "",
      value6: "",
      value7: false,
      value8: false,
      value9: "",
      value10: "",
      value11: "",
      value12: "",
      value13: "",
      value14: "",
      value15: "",
      value16: "",
      value17: "",
      value18: "",
      value19: "",
      value20: "",
      value21: "",
      value22: "",
      value23: "",
    };
    setData((prev) => [...prev, newRow]);
  };

  const handleChangeValue = (id, name, value) => {
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };

  const handleDelete = (id) => {
    setData((prev) => prev.filter((item) => item.id !== id));
  };

  return (
    <Box display="flex" flexDirection="column" mt={1}>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td
                className="toggle-button"
                rowSpan={2}
                style={{ textAlign: "center", fontWeight: "bold", minWidth: 0 }}
              >
                STT
                <div className="button-action">
                  <button type="button" onClick={() => handleAdd("muc1")}>
                    Thêm dòng
                  </button>
                </div>
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", fontWeight: "bold" }}>
                Họ và tên người nộp thuế
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", fontWeight: "bold" }}>
                MST (ghi trong trường hợp thay đổi thông tin)
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", fontWeight: "bold" }}>
                Ngày sinh
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", fontWeight: "bold" }}>
                Giới tính
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", fontWeight: "bold" }}>
                Quốc tịch
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", fontWeight: "bold" }}>
                Người Việt Nam (sống ở nước ngoài)
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", fontWeight: "bold" }}>
                CMND kê khai sai
              </Td>
              <Td rowSpan={1} colSpan={4} style={{ textAlign: "center", fontWeight: "bold" }}>
                Giấy tờ chứng thực cá nhân
              </Td>
              <Td rowSpan={1} colSpan={5} style={{ textAlign: "center", fontWeight: "bold" }}>
                Địa chỉ thường trú
              </Td>
              <Td rowSpan={1} colSpan={4} style={{ textAlign: "center", fontWeight: "bold" }}>
                Địa chỉ hiện tại
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", fontWeight: "bold" }}>
                Điện thoại liên hệ
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", fontWeight: "bold" }}>
                Email
              </Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                Loại giấy tờ tùy thân của cá nhân (CMND/CCCD/Hộ chiếu)
              </Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>Số giấy tờ</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>Ngày cấp</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>Nơi cấp</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>Số nhà/đường/phố</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>Xã, phường</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>Quận, huyện</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>Tỉnh, thành phố</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>Quốc gia</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>Số nhà/đường/phố</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>Xã, phường</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>Quận, huyện</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>Tỉnh, thành phố</Td>
            </tr>
            {data &&
              data.length &&
              data.map((item, index) => (
                <tr key={item.id}>
                  <Td
                    className="toggle-button"
                    style={{ textAlign: "center", fontWeight: "bold", minWidth: 0 }}
                  >
                    {index + 1}
                    <div className="button-action delete">
                      <button type="button" onClick={() => handleDelete(item.id)}>
                        Xóa dòng
                      </button>
                    </div>
                  </Td>
                  <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                    <InputTable
                      id={item.id}
                      type="text"
                      name="value2"
                      value={item.value2}
                      onChange={handleChange}
                    />
                  </Td>
                  <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                    <InputTable
                      id={item.id}
                      type="text"
                      name="value3"
                      value={item.value3}
                      onChange={handleChange}
                    />
                  </Td>
                  <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                    <DatePicker
                      style={selectStyle}
                      options={{
                        locale: Vietnamese,
                        time_24hr: true,
                        dateFormat: "d-m-Y",
                      }}
                      name="value4"
                      onChange={(e) => handleChangeValue(item.id, "value4", e[0])}
                    />
                  </Td>
                  <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                    <select
                      style={selectStyle}
                      onChange={(e) => handleChangeValue(item.id, "value5", e.target.value)}
                    >
                      <option value="Nam">Nam</option>
                      <option value="Nữ">Nữ</option>
                      <option value="Khác">Khác</option>
                    </select>
                  </Td>
                  <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                    <select
                      style={selectStyle}
                      onChange={(e) => handleChangeValue(item.id, "value6", e.target.value)}
                    >
                      <option value="Việt Nam">Việt Nam</option>
                      <option value="Mỹ">Mỹ</option>
                    </select>
                  </Td>
                  <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                    <Switch
                      size="medium"
                      name="tbCheckbox1"
                      onChange={(e) => handleChangeValue(item.id, "value7", e.target.checked)}
                    />
                  </Td>
                  <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                    <Switch
                      size="medium"
                      name="tbCheckbox2"
                      onChange={(e) => handleChangeValue(item.id, "value8", e.target.checked)}
                    />
                  </Td>
                  <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                    <select
                      style={selectStyle}
                      onChange={(e) => handleChangeValue(item.id, "value9", e.target.value)}
                    >
                      <option value="value1">value1</option>
                      <option value="value2">value2</option>
                    </select>
                  </Td>
                  <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                    <InputTable
                      id={item.id}
                      type="text"
                      name="value10"
                      value={item.value10}
                      onChange={handleChange}
                    />
                  </Td>
                  <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                    <DatePicker
                      style={selectStyle}
                      options={{
                        locale: Vietnamese,
                        time_24hr: true,
                        dateFormat: "d-m-Y",
                      }}
                      name="ngayCap"
                      onChange={(e) => handleChangeValue(item.id, "value11", e[0])}
                    />
                  </Td>
                  <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                    <select
                      style={selectStyle}
                      onChange={(e) => handleChangeValue(item.id, "value12", e.target.value)}
                    >
                      <option value="value1">value1</option>
                      <option value="value2">value2</option>
                    </select>
                  </Td>
                  <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                    <InputTable
                      id={item.id}
                      type="text"
                      name="value13"
                      value={item.value13}
                      onChange={handleChange}
                    />
                  </Td>
                  <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                    <select
                      style={selectStyle}
                      onChange={(e) => handleChangeValue(item.id, "value14", e.target.value)}
                    >
                      <option value="value1">value1</option>
                      <option value="value2">value2</option>
                    </select>
                  </Td>
                  <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                    <select
                      style={selectStyle}
                      onChange={(e) => handleChangeValue(item.id, "value15", e.target.value)}
                    >
                      <option value="value1">value1</option>
                      <option value="value2">value2</option>
                    </select>
                  </Td>
                  <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                    <select
                      style={selectStyle}
                      onChange={(e) => handleChangeValue(item.id, "value16", e.target.value)}
                    >
                      <option value="value1">value1</option>
                      <option value="value2">value2</option>
                    </select>
                  </Td>
                  <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                    <select
                      style={selectStyle}
                      onChange={(e) => handleChangeValue(item.id, "value17", e.target.value)}
                    >
                      <option value="value1">value1</option>
                      <option value="value2">value2</option>
                    </select>
                  </Td>
                  <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                    <InputTable
                      id={item.id}
                      type="text"
                      name="value18"
                      value={item.value18}
                      onChange={handleChange}
                    />
                  </Td>
                  <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                    <select
                      style={selectStyle}
                      onChange={(e) => handleChangeValue(item.id, "value19", e.target.value)}
                    >
                      <option value="value1">value1</option>
                      <option value="value2">value2</option>
                    </select>
                  </Td>
                  <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                    <select
                      style={selectStyle}
                      onChange={(e) => handleChangeValue(item.id, "value20", e.target.value)}
                    >
                      <option value="value1">value1</option>
                      <option value="value2">value2</option>
                    </select>
                  </Td>
                  <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                    <select
                      style={selectStyle}
                      onChange={(e) => handleChangeValue(item.id, "value21", e.target.value)}
                    >
                      <option value="value1">value1</option>
                      <option value="value2">value2</option>
                    </select>
                  </Td>
                  <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                    <InputTable
                      id={item.id}
                      type="text"
                      name="value22"
                      value={item.value22}
                      onChange={handleChange}
                    />
                  </Td>
                  <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                    <InputTable
                      id={item.id}
                      type="text"
                      name="value23"
                      value={item.value23}
                      onChange={handleChange}
                    />
                  </Td>
                </tr>
              ))}
          </tbody>
        </table>
      </Box>
    </Box>
  );
}

export default memo(TaxPersonalTable);

function InputTable(props) {
  const { onChange, type = "text", name, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (type === "text") {
      onChange({ value, name, type });
    } else {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ value: newValue !== "" ? +newValue : "", name, type });
    }
  }
  return (
    <input
      type={type}
      name={name}
      style={{
        textAlign: type === "text" ? "left" : "right",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.2rem 0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
